import { IReportSettingEditInput } from '../../../../utils/apollo/graphqlSchema';
import { IReportSettingsFormState } from './types';

export const prepareReportSettingEditInput = (
  formData: IReportSettingsFormState,
): IReportSettingEditInput => {
  const { funnel, inspect } = formData;

  return {
    funnel,
    inspect: {
      schemaInspectSettings: inspect.schemaInspectSettings.map(
        ({ schemaKey, fields }) => ({
          schemaKey,
          fieldKeys: fields.map((field) => field.key),
        }),
      ),
    },
  };
};
